import { render, staticRenderFns } from "./SidePanelNeedsAnswer.vue?vue&type=template&id=9de9e694&scoped=true&"
import script from "./SidePanelNeedsAnswer.vue?vue&type=script&lang=js&"
export * from "./SidePanelNeedsAnswer.vue?vue&type=script&lang=js&"
import style0 from "./SidePanelNeedsAnswer.vue?vue&type=style&index=0&id=9de9e694&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de9e694",
  null
  
)

export default component.exports